import { Button, Form, Radio, Space, Select, Row, Col, Avatar, Tooltip, Upload, Tabs, Checkbox, Input, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../utils/eventEmitter';


const userColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Login',
    dataIndex: 'login',
    key: 'login',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
]


const GroupChanges = () => {
  const { group } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  

  
  const save = () => {
    let data = form.getFieldsValue();
    
    // create(data_, success);
    // console.log(data);
  }

  const edit = () => { 
    let data = form.getFieldsValue();
    
    
    // update(user.seo, data_, success);
    // console.log(data)
  };

  useEffect(() => {
    EventEmitter.subscribe('groups', data => {
      navigate('/app/groups/'+data);
    });
    
    return () => EventEmitter.unsubscribe('groups');
  },[])


  

  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-bold'>
            <Link to={'/settings/users'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Users</Link> / {params.action}
            <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={group.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
          </h3>
          {group.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
        </div>
        
      </div>  
      <div className='mt-5 p-3 bg-white shadow p-3'>
        
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 5  }}
          labelWrap={true}
          initialValues={group.seo ? {...group} : {}}
          autoComplete="off"
          variant='borderless'
        >
          <Row className='mb-5'>
            <Col md={{ span: 11 }}>
              <Form.Item label='Name' name="name" className='font-bold mb-1' >
                <Input type='text' className='input-outline-none w-full font-normal'/>
              </Form.Item>
            </Col>
            <Col md={{ span: 11, offset: 1 }}>
              <Form.Item label='Application' name="application_id" className='font-bold mb-1' >
                <Input type='text' className='input-outline-none w-full font-normal'/>
              </Form.Item>
            </Col>
          </Row>
          
          <Tabs
            type='card'
            items={[
              {
                key: '1',
                label: 'Users',
                children: 
                <Table 
                  columns={userColumns}
                  rowClassName={'hover:cursor-pointer'}
                  dataSource={userData}
                  pagination={false}
                  rowKey={'name'}
                />
              },
              {
                key: '2',
                label: 'Preferences',
                children: 
                <Row>
                  <Col md={{span: 11}}>
                    <Form.Item label='Default Warehouse' name="default_warehouse" className='font-bold mb-1' >
                      {/* <Select options={warehouses.map(warehouse => ({value: warehouse.id, label: warehouse.name}))} className='font-normal' /> */}
                    </Form.Item>
                  </Col>
                </Row>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default GroupChanges;